import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about.html',
  styleUrl: './about.scss',
})
export class About {
  ts = inject(TranslationService);
  t = this.ts.t;

  steps = computed(() => [
    { num: '01', title: this.t().about_step1_title, desc: this.t().about_step1_desc },
    { num: '02', title: this.t().about_step2_title, desc: this.t().about_step2_desc },
    { num: '03', title: this.t().about_step3_title, desc: this.t().about_step3_desc },
    { num: '04', title: this.t().about_step4_title, desc: this.t().about_step4_desc },
  ]);

  stats = computed(() => [
    { num: '+200', label: this.t().about_stat1_label },
    { num: '99.9%', label: this.t().about_stat2_label },
    { num: '50k+', label: this.t().about_stat3_label },
    { num: '2M+', label: this.t().about_stat4_label },
  ]);
}
